//
//
//
//
//
//
//
//
//
//
//
//
//

import Tooltip from '@/mixins/tooltip';

export default {
  name: 'EditorHint',
  mixins: [Tooltip],
  props: {
    icon: { type: String, default: null },
  },
};
